import React, { useEffect, useState } from 'react';
import opsService from '../../../services/opsService';

export default function OrdersList({ refreshKey }) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    opsService.listOrders().then(setRows).catch(() => setRows([]));
  }, [refreshKey]);

  return (
    <div className="bg-surface-card rounded-card shadow-elevation-1 border overflow-hidden">
      <div className="px-4 py-2 font-medium text-ink-soft border-b">Purchase orders</div>
      <table className="w-full text-small">
        <thead className="bg-surface-muted text-ink-muted">
          <tr>
            <th className="text-left px-4 py-2">Order #</th>
            <th className="text-left px-4 py-2">Ref</th>
            <th className="text-left px-4 py-2">Status</th>
            <th className="text-left px-4 py-2">Total</th>
            <th className="text-left px-4 py-2">Source</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((o) => (
            <tr key={o.id} className="border-t">
              <td className="px-4 py-2 text-ink-soft">{o.order_number}</td>
              <td className="px-4 py-2">{o.external_order_ref || '—'}</td>
              <td className="px-4 py-2">{o.status}</td>
              <td className="px-4 py-2">{o.total != null ? `${o.currency} ${o.total}` : '—'}</td>
              <td className="px-4 py-2">{o.source}</td>
            </tr>
          ))}
          {rows.length === 0 && (
            <tr><td colSpan="5" className="px-4 py-6 text-center text-ink-muted">No orders yet.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
